import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import SpecificTabVis from './SpecificTabVis';
import SpecificTabUsr from './SpecificTabUsr';
import lang from '../../Lang/lang.json';
import Icons from '../../../Containers/Icons';

class SpecificTab extends Component {
  constructor() {
    super();
    this.state = {
      vis: [],
      users: []
    }
  }
  componentDidMount() {
    console.log("did mount")
    this.getAllVisualsAndUsers();
    this.props.changeScreen("SelectedTab");
  }
  componentWillReceiveProps() {
    this.getAllVisualsAndUsers();
  }
  getAllVisualsAndUsers = () => {
    let bodyCall = {
      type: "read",
      screen: "tab-conf-uniq",
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      if (res && (res.tkn === false)) {
        this.props.history.push("/");
      } else {
        let vis = res.visuals;
        let usr = res.users;
        Object.keys(vis).map(el => {
          vis[el].active = this.checkVisualesAndUserPer(vis[el].id, "visuales");
          return true
        })
        Object.keys(usr).map(el => {
          usr[el].edit = this.checkVisualesAndUserPer(usr[el].id, "edit");
          usr[el].view = this.checkVisualesAndUserPer(usr[el].id, "view");
          return true
        })
        this.setState({vis: vis, users: usr})
      }
    })
  }
  checkVisualesAndUserPer = (key, col) => {
    if (this.props.tab) {
      let tab = JSON.parse(this.props.tab[col]);
      let selected = tab.find(el => {
        return el === parseInt(key, 10)
      })
      if (selected === undefined) {
        return false
      } else {
        return true
      }
    }
    
  }
  changeActVis = (id, key) => {
    let bodyCall = {
      type: "update",
      screen: "tab-visuals",
      post: {
        visID: parseInt(id, 10),
        tabID: this.props.tab.id
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      if(res.tkn === false) {
        this.props.history.push('/')
      } else {
        let vis = {...this.state.vis};
        vis[key].active
        ? vis[key].active = false
        : vis[key].active = true
        this.setState({vis})
      }
    })
  }
  changeUsrPer = (id, per) => {
    let bodyCall = {
      type: "update",
      screen: "user-tab-permissions",
      post: {
        uID: parseInt(id, 10),
        tabID: this.props.tab.id,
        [per]: true
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      console.log(res)
      let users = {...this.state.users};
      let sel = Object.keys(users).find(el => {
        return users[el].id === id
      })
      users[sel][per]
      ? users[sel][per] = false
      : users[sel][per] = true
      this.setState({users})
    })
  }
  deleteTablero = () => {
    let bodyCall = {
      type: "delete",
      screen: "tab",
      post: {
        id: this.props.tab.id,
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      this.props.readTabs();
      this.props.funct('TabCnfDel');
      this.props.msg("ok", "e13");
      this.props.history.push('/home/admin/tabs');
    })
  }
  render() {
    if ((this.props.tab !== undefined) && (this.state.vis !== undefined)) {
      let vis = {...this.state.vis};
      let openModDel;
      this.props.openModDel
      ? openModDel = "open"
      : openModDel = "closed"
      return (
        <div id="specificTab">
          <h3>Marca los puntos visuales activos</h3>
          <SpecificTabVis vis={vis} changeActVis={this.changeActVis}/>
          <h3>Permisos de usuario</h3>
          <SpecificTabUsr usr={this.state.users} changeUsrPer={this.changeUsrPer}/>
          <div className={`modal delete ${openModDel}`}>
            <span className="formButton ok white" onClick={this.deleteTablero}>
              <Icons name="ok"/>
            </span>
            <span className="info">
              <h3>{lang.UsrCnf.delete[this.props.language]}</h3>
              <p>{lang.TabCnf.deleteinfo[this.props.language]}</p>
            </span>
            <span className="formButton close white" onClick={() => this.props.funct('TabCnfDel')}>
              <Icons name="close"/>
            </span>
          </div>
        </div>
      )
    } else {
      return (
        <div>Loading</div>
      )
    }
  }
}
export default withRouter(SpecificTab);


// WEBPACK FOOTER //
// ./src/Components/Admin/Tab/SpecificTab.js